import React from "react";
import "./MyBookingDetail.css";
import { useParams } from "react-router-dom";

export default function MyBookingDetail() {

  const { id } = useParams();

  
  // You can replace these with props or real data
  const cover =
    "https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=1600&auto=format&fit=crop"; // fallback image
  const event = {
    title: "Pure Vegetarian Food Party",
    venue: "Veggies Garden Palace",
    date: "10 Aug 2025",
    time: "10 PM - 01 AM",
    addressLine1: "Block K, Lajpat Nagar IV",
    addressLine2: "Lajpat Nagar, New Delhi, Delhi 110048",
    capacityNote: "Limited capacity event",
    guestsMax: 14,
    amountPaid: 4010,
    remainingAmount: 9990,
  };

  const formatINR = (n) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(n);

  return (
    <div className="pwbd-page">
      <div className="pwbd-container">
        <h1 className="pwbd-title">Payment Details</h1>

        <div className="pwbd-grid">
          {/* Left column */}
          <div className="pwbd-left">
            <div className="pwbd-coverCard">
              <img src={cover} alt="Event cover" className="pwbd-coverImg" />
            </div>

            <div className="pwbd-detailsCard">
              <div className="pwbd-headingBlock">
                <h2 className="pwbd-eventTitle">{event.title}</h2>
                <p className="pwbd-venueName">{event.venue}</p>
              </div>

              <div className="pwbd-infoRow">
                <div className="pwbd-iconWrap" aria-hidden>
                  {/* calendar icon */}
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="4" stroke="currentColor" />
                    <path d="M8 2v4M16 2v4M3 10h18" stroke="currentColor" />
                  </svg>
                </div>
                <div className="pwbd-infoText">
                  <div className="pwbd-bold">{event.date}</div>
                  <div className="pwbd-sub">{event.time}</div>
                </div>
              </div>

              <div className="pwbd-infoRow">
                <div className="pwbd-iconWrap" aria-hidden>
                  {/* location pin */}
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z"
                      stroke="currentColor"
                      fill="none"
                    />
                    <circle cx="12" cy="10" r="3" stroke="currentColor" />
                  </svg>
                </div>
                <div className="pwbd-infoText">
                  <div className="pwbd-bold">{event.addressLine1}</div>
                  <div className="pwbd-sub">{event.addressLine2}</div>
                </div>
              </div>

              <div className="pwbd-infoRow">
                <div className="pwbd-iconWrap" aria-hidden>
                  {/* users/guests */}
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <circle cx="8" cy="8" r="3.5" stroke="currentColor" />
                    <path d="M2.5 20c0-3 3-5 6-5" stroke="currentColor" />
                    <circle cx="17" cy="10" r="3" stroke="currentColor" />
                    <path d="M13 20c0-2.6 2.4-4.6 4.9-4.9" stroke="currentColor" />
                  </svg>
                </div>
                <div className="pwbd-infoText">
                  <div className="pwbd-bold">{event.guestsMax} Guests Maximum</div>
                  <div className="pwbd-sub">{event.capacityNote}</div>
                </div>
              </div>


            </div>
          </div>

          {/* Right column */}
          <aside className="pwbd-right">
            <div className="pwbd-summaryCard">
              <h3 className="pwbd-summaryTitle">Event Summary</h3>

              <div className="pwbd-qrWrap">
                {/* placeholder QR-like block */}
                <div className="pwbd-qrBox" aria-hidden>
                  <div className="pwbd-qrDot pwbd-qrDot--tl" />
                  <div className="pwbd-qrDot pwbd-qrDot--tr" />
                  <div className="pwbd-qrDot pwbd-qrDot--bl" />
                  <div className="pwbd-qrDot pwbd-qrDot--br" />
                </div>
                <div className="pwbd-qrSub">Scan for details</div>
              </div>

              <div className="pwbd-lineItem">
                <div className="pwbd-lineLeft">
                  <span className="pwbd-lineIcon" aria-hidden>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <rect x="2" y="5" width="20" height="14" rx="3" stroke="currentColor" />
                      <path d="M2 10h20" stroke="currentColor" />
                    </svg>
                  </span>
                  Amount Paid
                </div>
                <div className="pwbd-lineRight pwbd-success">
                  {formatINR(event.amountPaid)}
                </div>
              </div>

              <div className="pwbd-lineItem pwbd-lineItem--muted">
                <div className="pwbd-lineLeft">Remaining Amount</div>
                <div className="pwbd-lineRight">{formatINR(event.remainingAmount)}</div>
              </div>

              <button className="pwbd-btn pwbd-btnPrimary">Pay Now</button>
              <button className="pwbd-btn pwbd-btnGhost">RSVP List</button>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
